import React from 'react'
import picture from '../assets/ai.png'
import { RiArrowDropDownLine } from 'react-icons/ri'
const Header = () => {
  return (
    <header className="bg-[#FFFFFF] shadow-sm py-4 px-6 rounded-e-lg">
    <div className="flex justify-between items-center">
      {/* Left Section */}
      <div className='flex items-center space-x-3'>
        <h1 className="text-3xl font-bold ">
         Grade <span className='text-[#FEA769]'>AI</span>
        </h1>
        <div className='flex '>
        <img
          src={picture}
          alt="Profile"
          className="w-6 h-6 object-contain"
        />
         <img
          src={picture}
          alt="Profile"
          className="w-12 h-12 object-contain"
        />
        </div>
      </div>

      {/* Right Section */}
      <div className="flex items-center space-x-3">
        {/* Notifications with count */}
        <div className="relative flex items-center justify-center w-10 h-10 ">
          <img src={require('../assets/Notif & Theme.png')} alt='' className="w-7 h-7 text-gray-800 cursor-pointer " />
          <span className="absolute top-2 right-2 w-4 h-4 bg-primary rounded-full flex items-center justify-center">
            <span className="text-white text-xs">2</span>
          </span>
        </div>

        {/* Profile Picture  */}
        <img
          src={require('../assets/Profile Picture.png')} 
          alt="Profile"
          className="w-12 h-12 object-contain"
        />

        {/* User Info */}
        <div className="text-left  items-center  flex cursor-pointer">
          <p className="font-semibold text-gray-800">John Doe</p>
          <RiArrowDropDownLine className='w-8 h-8 cursor-pointer' />
        </div>

     
      </div>
    </div>
  </header>
  )
}

export default Header